"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var isNull_1 = __importDefault(require("lodash/isNull"));
var isFunction_1 = __importDefault(require("lodash/isFunction"));
var GeneralSettings_1 = require("../../../constants/GeneralSettings");
var SubscriptionPlans_1 = require("../../../constants/SubscriptionPlans");
var myAnnouncementsSlice_1 = require("../../../features/myAnnouncements/myAnnouncementsSlice");
var subscriptionSlice_1 = require("../../../features/subscription/subscriptionSlice");
var UpdateToTopIcon_1 = __importDefault(require("../../Icons/UpdateToTopIcon"));
var ActivationSwitch_1 = __importDefault(require("./ActivationSwitch"));
var deviceHelper_1 = require("../../../helpers/deviceHelper");
var CardActionsInfo_1 = __importDefault(require("./CardActionsInfo"));
var getSubscriptionPlanId_1 = require("../../../helpers/getSubscriptionPlanId");
var useDeviceResize_1 = require("../../../hooks/useDeviceResize");
var SubscriptionButton_1 = require("./SubscriptionButton");
var globalSlice_1 = require("../../../features/global/globalSlice");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var PostCardActions = function (_a) {
    var _b;
    var post = _a.post, onUpdateToTop = _a.onUpdateToTop, handleOpenEditPage = _a.handleOpenEditPage, onRemove = _a.onRemove, activatePost = _a.activatePost, onStatistic = _a.onStatistic, handleOpenDeactivationModal = _a.handleOpenDeactivationModal;
    var id = post.id, nextUpdatedToTop = post.nextUpdatedToTop, publicCode = post.publicCode, image = post.image, deal = post.deal, propertyType = post.propertyType, address = post.address, period = post.period, subscriptionPlans = post.subscriptionPlans, isDeveloper = post.isDeveloper;
    var dispatch = react_redux_1.useDispatch();
    var t = react_i18next_1.useTranslation('common').t;
    var mobileResize = useDeviceResize_1.useDeviceResize(useDeviceResize_1.MediaQueries.mobile);
    var activationLoading = react_redux_1.useSelector(myAnnouncementsSlice_1.toggleActiveLoadingSelector);
    var subscriptionPlanLoading = react_redux_1.useSelector(subscriptionSlice_1.selectSubscriptionPlanLoading);
    var isPublished = react_1.useCallback(function (status) {
        return status === GeneralSettings_1.POST_STATUSES.PUBLISHED;
    }, [GeneralSettings_1.POST_STATUSES.PUBLISHED]);
    var addSubscription = function (subscriptionPlanName) {
        var subscriptionPlanId = getSubscriptionPlanId_1.getSubscriptionPlanId(subscriptionPlanName);
        if (!subscriptionPlanId) {
            dispatch(globalSlice_1.addToastMessage({
                text: t('SUBSCRIPTION_PLANS_MODAL.TOAST_MESSAGES.REQUEST_ERROR'),
                appearance: 'error',
            }));
            return;
        }
        var postData = {
            id: id,
            publicCode: publicCode,
            image: image,
            deal: deal,
            propertyType: propertyType,
            address: address,
            isDeveloper: isDeveloper,
        };
        dispatch(subscriptionSlice_1.getSubscriptionPlan(subscriptionPlanId, postData));
    };
    var filteredSubscriptionPlans = react_1.useMemo(function () {
        return SubscriptionPlans_1.SUBSCRIPTION_PLANS.filter(function (subscription) {
            if (!subscriptionPlans.hasOwnProperty(subscription.name) &&
                isPublished(post.status)) {
                return !(subscription.name === GeneralSettings_1.GENERAL_SETTINGS.PLANS.TOUR_3D &&
                    !post.area);
            }
            else if (subscriptionPlans.hasOwnProperty(subscription.name)) {
                return subscription.name === GeneralSettings_1.GENERAL_SETTINGS.PLANS.PIN_TO_TOP;
            }
        });
    }, [subscriptionPlans]);
    return (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.post_actions, (_b = {},
            _b[styles_module_scss_1.default.is_paid] = post.isPinToTop,
            _b)) },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.subscriptions }, post.active &&
            filteredSubscriptionPlans.map(function (subscription, index) {
                var _a, _b;
                return (react_1.default.createElement(SubscriptionButton_1.SubscriptionButton, { key: index, extendedClassNames: subscription.btnExtendedStyles, subscriptionPlanLoading: subscriptionPlanLoading, subscriptionPlanName: subscription.name, subscriptionBtnIcon: subscription.btnIcon, addSubscription: addSubscription, subscriptionPlanEnd: (_b = (_a = subscriptionPlans[subscription.name]) === null || _a === void 0 ? void 0 : _a.end_date) !== null && _b !== void 0 ? _b : '' }));
            })),
        react_1.default.createElement("div", { className: mobileResize ? styles_module_scss_1.default.actionsMobile : styles_module_scss_1.default.actions },
            react_1.default.createElement("ul", null,
                isPublished(post.status) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(ActivationSwitch_1.default, { active: post.active, activationLoading: activationLoading, id: id, activatePost: activatePost, handleOpenDeactivationModal: handleOpenDeactivationModal }),
                    react_1.default.createElement("li", null,
                        post.active &&
                            !isNull_1.default(nextUpdatedToTop) &&
                            Date.now() <
                                Date.parse(nextUpdatedToTop) && (react_1.default.createElement(CardActionsInfo_1.default, { subjectName: t('MY_ANNOUNCEMENTS.UPDATE_TO_TOP'), infoDate: nextUpdatedToTop, additionalStyles: styles_module_scss_1.default.mobile_update_to_top_info })),
                        !post.active && !isNull_1.default(period) ? (react_1.default.createElement(CardActionsInfo_1.default, { subjectName: t('MY_ANNOUNCEMENTS.WILL_BE_ACTIVE'), infoDate: period })) : (react_1.default.createElement(UpdateToTopIcon_1.default, { isMobile: deviceHelper_1.isMobile(), id: id, isActive: post.active && !post.isPinToTop, nextUpdatedToTop: nextUpdatedToTop, updateToTopCount: post.updateToTopCount, onUpdateToTop: onUpdateToTop }))))),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("span", { onClick: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            isFunction_1.default(handleOpenEditPage) &&
                                handleOpenEditPage(id);
                        } },
                        react_1.default.createElement("i", { className: "cm-icon icon-ic-edit" }))),
                post.publishedAt && (react_1.default.createElement("li", null,
                    react_1.default.createElement("span", { onClick: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            isFunction_1.default(onStatistic) &&
                                onStatistic(post);
                        } },
                        react_1.default.createElement("i", { className: "cm-icon icon-ic-statistics" })))),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("span", { onClick: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            isFunction_1.default(onRemove) && onRemove(id);
                        } },
                        react_1.default.createElement("i", { className: "cm-icon icon-ic-remove" })))))));
};
exports.default = PostCardActions;
